// src/pages/ScheduleBlackoutsPage.jsx
import { useEffect, useState } from "react";
import MastersCrudPage from "../components/MastersCrudPage";
import {
  listBlackouts,
  createBlackout,
  updateBlackout,
  deleteBlackout,
  listResources,
  listLocations,
} from "../api/mastersApi";

export default function ScheduleBlackoutsPage() {
  const [resources, setResources] = useState([]);
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const data = await listResources();


        if (Array.isArray(data)) {
          setResources(data);
        } else if (data && Array.isArray(data.data)) {
          setResources(data.data);
        } else if (data && Array.isArray(data.resources)) {
          // por si la API devuelve { resources: [...] }
          setResources(data.resources);
        } else if (data && Array.isArray(data.locations)) {
          // por si la API devuelve { locations: [...] }
          setResources(data.locations);
        } else {
          setResources([]); // fallback seguro
        }        

       
      } catch (err) {
        console.error("Error listResources", err);
        setResources([]);
      }
  
      try {
        const data = await listLocations();

        if (Array.isArray(data)) {
          setLocations(data);
        } else if (data && Array.isArray(data.data)) {
          setLocations(data.data);
        } else if (data && Array.isArray(data.resources)) {
          // por si la API devuelve { resources: [...] }
          setLocations(data.resources);
        } else if (data && Array.isArray(data.locations)) {
          // por si la API devuelve { locations: [...] }
          setLocations(data.locations);
        } else {
          setLocations([]); // fallback seguro
        }   

        
      } catch (err) {
        console.error("Error listLocations", err);
        setLocations([]);
      }
    })();
  }, []);

  return (
    <MastersCrudPage
      title="Schedule Blackouts"
      fetchList={listBlackouts}
      createItem={createBlackout}
      updateItem={updateBlackout}
      deleteItem={deleteBlackout}
      columns={[
        { key: "id", label: "ID" },
        { key: "resource_name", label: "Recurso" },
        { key: "location_name", label: "Sede" },
        { key: "starts_at", label: "Inicio" },
        { key: "ends_at", label: "Fin" },
        { key: "reason", label: "Motivo" },
      ]}
      initialForm={() => ({ resource_id: null, location_id: null, starts_at: "", ends_at: "", reason: "" })}
      renderForm={({ form, setForm }) => (
        <>
          <div className="grid grid-cols-2 gap-2">
            <div>
              <label className="block text-xs text-gray-400">Recurso</label>
              <select value={form.resource_id ?? ""} onChange={e=> setForm({...form, resource_id: e.target.value ? Number(e.target.value) : null})} className="w-full p-2 rounded bg-[#020817] border border-gray-700">
                <option value="">-- sin recurso --</option>
                {resources.map(r => <option key={r.id} value={r.id}>{r.name}</option>)}
              </select>
            </div>
            <div>
              <label className="block text-xs text-gray-400">Sede</label>
              <select value={form.location_id ?? ""} onChange={e=> setForm({...form, location_id: e.target.value ? Number(e.target.value) : null})} className="w-full p-2 rounded bg-[#020817] border border-gray-700">
                <option value="">-- sin sede --</option>
                {locations.map(l => <option key={l.id} value={l.id}>{l.name}</option>)}
              </select>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-2">
            <div>
              <label className="block text-xs text-gray-400">Inicio</label>
              <input type="datetime-local" value={form.starts_at ? form.starts_at.slice(0,16) : ""} onChange={e => setForm({...form, starts_at: e.target.value ? e.target.value.replace("T"," ") : ""})} className="w-full p-2 rounded bg-[#020817] border border-gray-700" />
              <small className="text-xs text-gray-400">Local time</small>
            </div>
            <div>
              <label className="block text-xs text-gray-400">Fin</label>
              <input type="datetime-local" value={form.ends_at ? form.ends_at.slice(0,16) : ""} onChange={e => setForm({...form, ends_at: e.target.value ? e.target.value.replace("T"," ") : ""})} className="w-full p-2 rounded bg-[#020817] border border-gray-700" />
            </div>
          </div>

          <div>
            <label className="block text-xs text-gray-400">Motivo</label>
            <input value={form.reason} onChange={e => setForm({...form, reason: e.target.value})} className="w-full p-2 rounded bg-[#020817] border border-gray-700" />
          </div>
        </>
      )}
    />
  );
}
